'use strict';

import intlTelInput from 'intl-tel-input';
import 'chosen-js';

const input = document.querySelector("#complaintForm-phone");
if (input) {
    intlTelInput(input, {
        initialCountry: "it",
        separateDialCode: true,
        loadUtils: () => import("intl-tel-input/build/js/utils.js"),
    });

    input.addEventListener("input", function () {
        this.value = this.value.replace(/[^\d+]/g, "");

        if (this.value.length > 15) {
            this.value = this.value.slice(0, 15);
        }
    });
}

const form = $('#ComplaintCreationForm');

if (form.length > 0) {
    form[0].reset();
}

form.find('button[type="submit"], input[type="submit"]').on('click', function () {
    const $checkboxes = $('.topic-checkbox');
    if ($checkboxes.length > 0) {
        const checkedCount = $checkboxes.filter(':checked').length;
        const $formGroup = $checkboxes.closest('.form-group');
        const $feedback = $formGroup.find('.invalid-feedback');

        if (checkedCount === 0) {
            $formGroup.addClass('is-invalid');
            $feedback.removeClass('d-none').addClass('d-block');
        } else {
            $formGroup.removeClass('is-invalid');
            $feedback.removeClass('d-block').addClass('d-none');
        }
    }

    $('.chosen-select').removeClass('is-invalid');
});

form.on('submit', function (e) {
    const phoneInputField = document.querySelector('#complaintForm-phone');
    const iti = window.intlTelInputGlobals.getInstance(phoneInputField);

    if (iti) {
        phoneInputField.value = iti.getNumber();
    }

    const $checkboxes = $('.topic-checkbox');
    if ($checkboxes.length > 0) {
        const checkedCount = $checkboxes.filter(':checked').length;
        const $formGroup = $checkboxes.closest('.form-group');

        if (checkedCount === 0) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $formGroup.offset().top - 100
            }, 500);
        }
    }
});

// Bubble phase on document: runs after every validation handler bound on the form,
// so the spinner starts only when the submit is not blocked
document.addEventListener('submit', function (e) {
    if (e.target.id !== 'ComplaintCreationForm' || e.defaultPrevented) return;
    // The veil also blocks double clicks; the button stays enabled since its name is posted with the form
    $.spinner().start();
});

// Back/forward cache restores the page as it was left: remove the spinner
window.addEventListener('pageshow', function (e) {
    if (e.persisted) $.spinner().stop();
});

$('#ComplaintCreationForm #privacyOptIn').on('click', function () {
    $('.js-accept-privacy').addClass('hidden');
});

if ($('#successfulSubmit').length) {
    localStorage.clear();
}

$('#complaintForm-orderN').on('keydown', function (e) {
    if (['+', '-', '.', ','].includes(e.key) || e.key === 'e') {
        e.preventDefault();
    }
}).on('input', function () {
    this.value = this.value.replace(/[^0-9]/g, '');
});

$(document).ready(function () {
    $('.chosen-select').chosen('destroy').chosen({
        no_results_text: "Nessun risultato trovato per:",
        width: "100%",
        search_contains: true,
        allow_single_deselect: true
    }).next('.chosen-container').find('.chosen-single').attr('tabindex', '0');

    const $checkboxes = $('.topic-checkbox');

    $checkboxes.prop('required', false);

    $checkboxes.off('click change mousedown mouseup');

    $checkboxes.on('click change', function(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();

        const selectedValues = $('.topic-checkbox:checked').map(function() {
            return $(this).val();
        }).get();

        $('#selectedTopics').val(selectedValues.join(';'));

        if (selectedValues.length > 0) {
            const $formGroup = $(this).closest('.form-group');
            $formGroup.removeClass('is-invalid error');
            $formGroup.find('.invalid-feedback').css('display', 'none');
        }

        $(this).trigger('blur');
    });

    var birthdateInput = $('#complaintForm-birthday');
    var today = new Date();
    var minAge = 18;
    var maxAge = 100;
    var maxDate = new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate());
    var minDate = new Date(today.getFullYear() - maxAge, today.getMonth(), today.getDate());
    var maxDateFormatted = maxDate.toISOString().split('T')[0];
    var minDateFormatted = minDate.toISOString().split('T')[0];

    birthdateInput.attr('max', maxDateFormatted);
    birthdateInput.attr('min', minDateFormatted);
});
